module.exports = __webpack_public_path__ + "static/teleco_3-3ea4f2728eb2b933df434c02c44d180a.jpg";